var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"f-c-c-c container"},[_c('a',{attrs:{"href":_vm.PDAApkUrl,"download":"warehouse.apk"}},[_vm._v("Download Warehouse App")])])
}
var staticRenderFns = []

export { render, staticRenderFns }